module.exports = __webpack_public_path__ + "static/yellowConvoBubble-efd3c726c6687fd42498abb5331eeb11.png";